export enum RESET_PASSWORD {
    /**
     * @value A link to reset your password has been sent to
     */
    LINK_HAS_BEEN_SENT_TO = 'LINK_HAS_BEEN_SENT_TO',
    /**
     * @value Send reset link
     */
    LOGIN_RESET_LINK_BUTTON = 'LOGIN.RESET_LINK_BUTTON',
    /**
     * @value Enter your email address and we will send you a password reset link
     */
    LOGIN_RESET_LINK_TEXT = 'LOGIN.RESET_LINK_TEXT',
}
